import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import customerApi from '../api/customer'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    itemsPerPage: 20,
    customers: []
  },

  getters: {
    allCustomers: state => state.customers
  },

  actions: {
    getCustomers: ({ commit }) => {
      customerApi.all(customers => {
        commit(types.FETCH_CUSTOMERS, { customers })
      })
    },
    addCustomer: ({ commit }, customer) => {
      customerApi.create(customer, customer => {
        commit(types.CREATE_CUSTOMER, { customer })
      })
    }
  },

  mutations: {
    [types.FETCH_CUSTOMERS] (state, { customers }) {
      // Only load data from external source once
      if (state.customers.length === 0) {
        state.customers = customers
      }
    },
    [types.CREATE_CUSTOMER] (state, { customer }) {
      state.customers.push(customer)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js